import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Create a new supplier
export const createSupplier = async (supplierData) => {
  try {
    const response = await api.post(`${API_BASE_URL}api/supplier/create`, supplierData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to create supplier";
  }
};

// Get all suppliers
export const fetchSuppliers = async () => {
  try {
    const lang = localStorage.getItem("lang") || "en";
    const response = await api.get(`${API_BASE_URL}api/supplier/list`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("token")}`,
        "Accept-Language": lang,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Fetch Suppliers API Error:", error);
    throw error;
  }
};

// Update a supplier
export const updateSupplier = async (id, supplierData) => {
  try {
    const response = await api.put(`${API_BASE_URL}api/supplier/update/${id}`, supplierData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // if using auth
      },
    });
    return response.data;
  } catch (error) {
    console.error("Update Supplier API Error:", error);
    throw error;
  }
};

// Delete a supplier
export const deleteSupplier = async (id) => {
  try {
    const response = await api.delete(`${API_BASE_URL}api/supplier/delete/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Delete Supplier API Error:", error);
    throw error;
  }
};